export function isAnEmptyArray(arr) {
  if (arr == null) {
    return true;
  }
  if (Array.isArray(arr) === false) {
    return false;
  }
  return arr.length === 0;
}
export function isNotAnEmptyArray(arr) {
  return !isAnEmptyArray(arr);
}